import { render, staticRenderFns } from "./ThemePin.vue?vue&type=template&id=2c8395a0&scoped=true&xmlns%3Av-click-outside=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./ThemePin.vue?vue&type=script&lang=js&"
export * from "./ThemePin.vue?vue&type=script&lang=js&"
import style0 from "./ThemePin.vue?vue&type=style&index=0&id=2c8395a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8395a0",
  null
  
)

export default component.exports